export const DOCS_HOME = "https://docs.rujira.network";
export const SITE_URL = "https://rujira.network";
export const AUTOMATED_TRADING_PATH =
  "/trade/BTC/USDC?type=automated";
export const BRUNE_STAKING_PATH = "/stake/bRUNE";
export const RECURRING_BUYS_PATH =
  "/trade/BTC/USDC?type=manual&order=recurring";
export const ENSHRINED_ORACLES_URL = `${SITE_URL}/enshrined-oracles`;
export const GET_STARTED_URL = `${SITE_URL}/get-started`;
export const OMNICHAIN_URL = `${SITE_URL}/omnichain`;
export const ROADMAP_URL = `${SITE_URL}/roadmap`;
export const RUJI_TOKEN_URL = `${SITE_URL}/ruji-token`;
export const SECURED_ASSETS_URL = `${SITE_URL}/secured-assets`;
export const HOME_BEND_COLORS = ["#8436F5", "#5A2AD1"];
